'use client';
import { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import type { TcData } from 'types/consent';
import styles from './default.module.scss';

export type UserInfo = {
  email: string;
  hasSubscription: boolean;
  name: null | string;
  surname: null | string;
};

export type AuthData = {
  loggedIn: boolean;
  userInfo?: UserInfo;
  error?: string;
};

const PLENIGO_URL = process.env.NEXT_PUBLIC_PLENIGO_URL;

export const WidgetLoginDefault = () => {
  const [host, setHost] = useState('');
  const [userData, setUserData] = useState<AuthData>({ loggedIn: false });
  const href = usePathname();

  useEffect(() => {
    if (process) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setHost(window.location.host);

      window.addEventListener('message', function (e) {
        if (e.origin === `https://${host}` && e.data?.authData) {
          if (e.data.authData.userInfo?.hasSubscription && window.__tcfapi) {
            window.__tcfapi('postRejectAll', 2, function (_postRejectAllResponse: TcData, success: boolean) {
              console.log('pur login was successful: ' + success);
            });
          }
          setUserData(e.data.authData);
        }
      });

      const bridge = document.getElementById('bridge') as HTMLIFrameElement;

      if (bridge && host !== '' && !userData.loggedIn) {
        bridge.contentWindow?.postMessage({ authCommand: 'validateAuthData' }, `https://${host}`);
      }
    }
  }, [host, userData]);

  const logout = () => {
    const bridge = document.getElementById('bridge') as HTMLIFrameElement;
    if (typeof window._sp_ === 'object' && typeof window._sp_.deleteConsentCookies === 'function') {
      const { deleteConsentCookies } = window._sp_;
      deleteConsentCookies().then(() => {
        console.log('Consent Cookies deleted');
        if (bridge && host !== '') {
          bridge.contentWindow?.postMessage({ authCommand: 'logout' }, `https://${host}`);
          window.location.href = `${PLENIGO_URL}/logout?wdycf=https://${host}/pur/bridge.html?redi=${href}`;
        }
      });
    }
  };

  return (
    <div>
      <p className={styles.title}>RTL.de Werbefrei</p>
      <p className={styles.text}>
        {userData.loggedIn ? (
          <>
            Du bist eingeloggt
            <br />
          </>
        ) : (
          <></>
        )}
        {userData.userInfo?.hasSubscription ? (
          <>du liest RTL.de aktuell werbefrei im Pur Abo.</>
        ) : (
          <>
            Direkt mit dem Pur abo loslegen. <br /> Weitestgehend werbefrei und ohne Tracking
          </>
        )}
      </p>
      <a
        className={styles.button}
        href={`${PLENIGO_URL}/${userData.loggedIn ? 'account' : 'offers'}?wdycf=https://${host}/pur/bridge.html?redi=${href}`}
        target="_blank"
        title={userData.loggedIn ? 'Zum Konto' : 'Jetzt abonnieren'}
      >
        {userData.loggedIn ? 'Zu deinem Konto' : 'Jetzt für 3,99 Euro abonnieren'}
      </a>
      <p className={styles.loginText}>
        {userData.loggedIn ? (
          <button className={styles.loginLink} onClick={logout} title="Abmelden">
            Abmelden
          </button>
        ) : (
          <>
            Bereits ein Pur Abo?{' '}
            <a
              className={styles.loginLink}
              href={`${PLENIGO_URL}/login?wdycf=https://${host}/pur/bridge.html?redi=${href}`}
              title="Anmelden"
            >
              Hier einloggen
            </a>
          </>
        )}
      </p>
    </div>
  );
};
